module.exports = __webpack_public_path__ + "static/img/indexTitle_new.f3b6d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/show/indexTitle/indexTitle_new.png
// module id = SmN4
// module chunks = 156